import React, { useState } from "react";
import { connect } from "react-redux";
import { any, arrayOf, bool, func, object, shape, string } from "prop-types";
import { Link } from "react-router-dom";
import ReadingStatus from "../ReadingListDownload/reading_status";
import OnboardingSection from "../../common/OnboardingSectionCreator/OnboardingSection";
import {
  markDocumentReadWoodland,
  postWoodlandForms,
} from "../../redux/actions";
import ReadingListDownload from "../ReadingListDownload/index";
import * as style from "./styles.module.scss";

const WoodlandGroupOnboarding = ({
  appData,
  readingListDownloads,
  markDocumentReadFunc,
}) => {
  const [currentlyReading, setCurrentlyReading] = useState(null);
  const readDocuments =
    (appData.woodlandGroupOnboarding &&
      appData.woodlandGroupOnboarding.readDocuments) ||
    [];

  const filenameFromUrl = (url) => url.split("/").slice(-1)[0];

  const readingList = readingListDownloads.map((download) => ({
    ...download,
    status: readDocuments.includes(filenameFromUrl(download.link))
      ? ReadingStatus.Done
      : ReadingStatus.Todo,
  }));

  const formsListWithStatus = [
    {
      status:
        appData.woodlandGroupOnboarding &&
        appData.woodlandGroupOnboarding.siteRules
          ? ReadingStatus.Done
          : ReadingStatus.Todo,
      title: "Site Rules",
      url: "woodland-group-onboarding/site-rules",
      text: "Complete",
      submitted: !!(
        appData.woodlandGroupOnboarding &&
        appData.woodlandGroupOnboarding.siteRules
      ),
    },
    {
      status:
        appData.woodlandGroupOnboarding &&
        appData.woodlandGroupOnboarding.policies
          ? ReadingStatus.Done
          : ReadingStatus.Todo,
      title: "Policies and Procedures",
      url: "woodland-group-onboarding/policies",
      text: "Complete",
      submitted: !!(
        appData.woodlandGroupOnboarding &&
        appData.woodlandGroupOnboarding.policies
      ),
    },
    {
      status:
        appData.woodlandGroupOnboarding &&
        appData.woodlandGroupOnboarding.handOuts
          ? ReadingStatus.Done
          : ReadingStatus.Todo,
      title: "Hand outs",
      url: "woodland-group-onboarding/hand-outs",
      text: "Complete",
      submitted: !!(
        appData.woodlandGroupOnboarding &&
        appData.woodlandGroupOnboarding.handOuts
      ),
    },
    {
      status:
        appData.woodlandGroupOnboarding &&
        appData.woodlandGroupOnboarding.machinery
          ? ReadingStatus.Done
          : ReadingStatus.Todo,
      title: "Machinery/Equipment Use",
      url: "woodland-group-onboarding/machinery",
      text: "Complete",
      submitted: !!(
        appData.woodlandGroupOnboarding &&
        appData.woodlandGroupOnboarding.machinery
      ),
    },
    {
      status:
        appData.woodlandGroupOnboarding &&
        appData.woodlandGroupOnboarding.training
          ? ReadingStatus.Done
          : ReadingStatus.Todo,
      title: "Continual Training ",
      url: "woodland-group-onboarding/training",
      text: "Complete",
      submitted: !!(
        appData.woodlandGroupOnboarding &&
        appData.woodlandGroupOnboarding.training
      ),
    },
  ];

  const assessmentWithStatus = [
    {
      status:
        appData.woodlandGroupOnboarding &&
        appData.woodlandGroupOnboarding.manualHandling
          ? ReadingStatus.Done
          : ReadingStatus.Todo,
      title: "Manual Handling",
      url: "woodland-group-onboarding/manual-handling",
      text: "Complete",
      submitted: !!(
        appData.woodlandGroupOnboarding &&
        appData.woodlandGroupOnboarding.manualHandling
      ),
    },
    {
      status:
        appData.woodlandGroupOnboarding &&
        appData.woodlandGroupOnboarding.fireSafety
          ? ReadingStatus.Done
          : ReadingStatus.Todo,
      title: "Fire Safety",
      url: "woodland-group-onboarding/fire-safety",
      text: "Complete",
      submitted: !!(
        appData.woodlandGroupOnboarding &&
        appData.woodlandGroupOnboarding.fireSafety
      ),
    },
    {
      status:
        appData.woodlandGroupOnboarding &&
        appData.woodlandGroupOnboarding.incidentReporting
          ? ReadingStatus.Done
          : ReadingStatus.Todo,
      title: "Incident Reporting",
      url: "woodland-group-onboarding/incident-reporting",
      text: "Complete",
      submitted: !!(
        appData.woodlandGroupOnboarding &&
        appData.woodlandGroupOnboarding.incidentReporting
      ),
    },
  ];

  const bookletRead = readDocuments.includes("agency_induction_v2.pdf");

  return (
    <div className="container text-bluishGray pb-2">
      <header className="row">
        <div className="col-12">
          <h2 className="section-header pt-2">Woodland Group Onboarding</h2>
        </div>
      </header>
      <div className="row">
        <div className="col-lg-6 pb-2">
          <div className={`${style.wrapper} section-body pt-1 mb-2 bg-white`}>
            <h5 className="px-1">Induction Booklet</h5>
            {readingList &&
              readingList.map((elem, i) => (
                <ReadingListDownload
                  key={i}
                  title={elem.title}
                  link={elem.link}
                  status={elem.status}
                  currentlyReading={currentlyReading}
                  setCurrentlyReading={setCurrentlyReading}
                  markDocumentRead={markDocumentReadFunc}
                  isLoading={false}
                  agreementText={elem.agreementText}
                />
              ))}
          </div>

          <OnboardingSection
            title="Induction Checklist"
            subtext="Please complete all of the below forms. Once you have submitted your forms you will be
            unable to edit them. If you have any queries about the forms,
            please speak to your HRGO Consultant."
            formsListWithStatus={formsListWithStatus}
            submit={() => {}}
          />
        </div>
        <div className="col-lg-6 pb-2">
          {bookletRead ? (
            // when induction part is finished show Assessments:
            <OnboardingSection
              title="Assessments"
              subtext="Please complete all of the below assessments. Once you have submitted
            the assessments you will be
            unable to come back to them. If you have any queries,
            please speak to your HRGO Consultant."
              formsListWithStatus={assessmentWithStatus}
              submit={() => {}}
            />
          ) : (
            <OnboardingSection
              title="Assessments"
              subtext="Assessments part will be revealed once the Induction Booklet has been read."
              formsListWithStatus={[]}
              submit={() => {}}
            />
          )}
        </div>
      </div>
      <div className="w-100 d-flex justify-content-end">
        <Link to="/profile" className="btn btn-primary px-3">
          Back to My Account
        </Link>
      </div>
    </div>
  );
};

WoodlandGroupOnboarding.propTypes = {
  appData: any,
  readingList: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
    })
  ),
  markDocumentReadFunc: func.isRequired,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
  readingListDownloads: state.core.umbracoContent.woodlandReadingList,
  woodlandGroupOnboarding: state.core.woodlandGroupOnboarding,
});

const mapDispatchToProps = {
  markDocumentReadFunc: markDocumentReadWoodland,
  postWoodlandFormsFunc: postWoodlandForms,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(WoodlandGroupOnboarding);
